<app-tooltip [disable]="disableTooltip" [dynamic]="false" message="{{tooltipMessage}}">
    <button (click)="addAdditionalInputClick()"
            [attr.data-cy]="buttonDataCy"
            [disabled]="disabled"
            class="add-additional-button" style="margin-bottom: 30px;">
        <span [attr.data-cy]="iconDataCy" class="iwp-icon-gen_add"></span>
        <span [attr.data-cy]="textDataCy">{{label}}</span>
    </button>
</app-tooltip>
